import { Component, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateDirective } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';
import { GameService } from '../../../shared/services/game.service';
import { GameRatingDetailsViewModel } from '../../../shared/models/gamerating';
import { MatCardModule } from "@angular/material/card";
import { PlayerListViewModel } from '../../../shared/models/player.model';
import { GamePlayerRankingModel } from '../../../shared/models/GameModels';

@Component({
  selector: 'app-grades-display-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, RouterModule, TranslateModule, UpperCasePipe, MatCardModule],
  templateUrl: './grades-display-dialog.component.html',
  styleUrl: './grades-display-dialog.component.css',
})
export class GradesDisplayDialogComponent {
  GameRankingDetails: GameRatingDetailsViewModel;
  ShowTeam: string;
  Players: PlayerListViewModel[] = [];
  PlayerRankings: GamePlayerRankingModel[] = [];
  

  readonly dialogRef = inject(MatDialogRef<GradesDisplayDialogComponent>);
  readonly data = inject(MAT_DIALOG_DATA);
  readonly router = inject(Router);
  readonly translate = inject(TranslateService);
  readonly activatedRoute = inject(ActivatedRoute);
  readonly gameService = inject(GameService);
  readonly cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    // Get GameId from dialog data
    let GameId = this.data.GameId;
    this.ShowTeam = this.data.Team;

    //Use the GameId to load game grades
    this.gameService.getGradesPerGame(GameId).subscribe({
      next: gameData => {
        this.GameRankingDetails = gameData;
        this.Players = (this.ShowTeam === 'Home' ? gameData?.HomeTeam?.Players : gameData?.AwayTeam?.Players) ?? [];
        //this.PlayerRankings = this.ShowTeam === 'Home' ? this.GameRankingDetails.PlayerRankings.GamePlayerRankingsHome : gameData.PlayerRankings.GamePlayerRankingsAway;
        this.cdr.detectChanges();
      },
      error: () => {
        this.Players = [];
        this.cdr.detectChanges();
      }
    });
  }

  GetPlayerGradeClass(LifelineScoutingId: string, playerRankings: any[]): string {
    let grade = playerRankings.find(pr => pr.PlayerId === LifelineScoutingId)?.Ranking;   
    switch (grade) {
      case 1:
        return 'rankingbox-red';
      case 2:
        return 'rankingbox-yellow';  
      case 3:
        return 'rankingbox-lightgreen';
      case 4:
        return 'rankingbox-green';
      case 5:
        return 'rankingbox-blue';
      default:
        return 'NoGrade';
    }    
  }

  getGrade(LifelineScoutingId: string, playerRankings: any[]): number | undefined {
    return playerRankings.find(pr => pr.PlayerId === LifelineScoutingId)?.Ranking;
  }

  

}
